export default __webpack_public_path__ + "static/media/hht2_direction_speakingbooster_03.949552e8.png";